<template>
  <div :class="{'align-center': $attrs.align ==='center'}" class="input-integer">
    <input
      ref="input"
      v-bind="$attrs"
      v-model="value"
      @blur="inputHandle"
      @change="changeHandle"
      class="form-control"
      type="number"
    ></input>
    <label>
      <span>{{ value }}</span>{{ $attrs.label }}</label>
  </div>
</template>
<script>
export default {
  name: "IntegerInput",
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: "",
    }
  },
  computed: {},
  mounted: function () {
    this.value = this.value ? parseInt(this.value) : "";
  },
  methods: {
    inputHandle() {
      if (this.value === "") {
        this.value = this.$attrs.min;
      }
      if (parseInt(this.value) > this.$attrs.max) {
        this.value = this.$attrs.max;
      }
    },
    changeHandle(e) {
      let value = this.$refs.input.value;
      if (this.value === "") {
        value = this.$attrs.min;
        this.value = this.$attrs.min;
      }
      this.$emit("change", value);
    },
  },
};
</script>
